var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    fill: "#fff",
    stroke: "#C11B1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.539 10.967a1.412 1.412 0 0 1 1.996-1.996l9.317 9.317a1.412 1.412 0 0 1-1.996 1.996l-9.318-9.317Z",
    fill: "#C11B1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.856 8.97a1.412 1.412 0 1 1 1.997 1.997l-9.317 9.317a1.412 1.412 0 0 1-1.997-1.996l9.317-9.317Z",
    fill: "#C11B1B"
  })));
};
export default SvgError;